import { act, useEffect, useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { useProfileStore } from "../../store/useUserStore";
import { useTranslation } from "react-i18next";

interface TabHeaderProps {
  defaultTab?: "school" | "explore" | "academy";
  showTabs?: ("school" | "explore" | "academy")[];
}

const TabHeader = ({
  defaultTab = "school",
  showTabs = ["school", "explore", "academy"],
}: TabHeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const authLogin = localStorage.getItem("parent_token");
  const { setShowLoginModal, setHomePageShow } = useProfileStore(
    (state) => state,
  );

  // Determine active tab based on current route or URL params
  const getActiveTabFromRoute = () => {
    if (location.pathname === "/") {
      return "explore";
    }
    if (location.pathname.startsWith("/school")) {
      return "school";
    }
    if (location.pathname.startsWith("/academy")) {
      return "academy";
    }
    if (location.pathname.match(/^\/[^\/]+\/[^\/]+/)) {
      // Branch/course routes are part of explore
      return "explore";
    }

    return defaultTab;
  };

  const [activeTab, setActiveTab] = useState<"school" | "explore" | "academy">(
    getActiveTabFromRoute(),
  );

  const handleTabChange = (tab: "school" | "explore" | "academy") => {
    // Check authentication for school and academy tabs
    setHomePageShow(tab);
    console.log("tab", tab);
    if ((tab === "school" || tab === "academy") && !authLogin) {
      setShowLoginModal(true);
      return;
    }

    setActiveTab(tab);
    if (tab === "explore") {
      navigate("/");
    } else if (tab === "school") {
      navigate("/school");
    } else if (tab === "academy") {
      navigate("/academy");
    }
  };

  const tabConfig = {
    school: {
      label: t("school"),
      key: "school",
    },
    explore: {
      label: t("explore.explore"),
      key: "explore",
    },
    academy: {
      label: t("academy"),
      key: "academy",
    },
  };

  return (
    <div className="flex border-b justify-around bg-white sticky top-0 z-10">
      {showTabs.map((tab) => (
        <button
          key={tab}
          onClick={() => handleTabChange(tab)}
          className={`px-4 py-2 text-base font-medium ${
            activeTab === tab
              ? "border-b-2 border-theme text-theme"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          {tabConfig[tab].label}
        </button>
      ))}
    </div>
  );
};

export default TabHeader;
